import React from 'react';
import { Grid, Button, Dropdown, Form } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';

const CreateMVForm = ({
  loading,
  submitLoading,
  handleSubmit,
  manufacturersDD,
  variantsDD,
  onChangeOfMrp,
  onChangeOfOfferPrice,
  onChangeOfVendorPrice,
  onChangeOfManufacturerId,
  onChangeOfVariantId
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Create New Manufacturer Variant</title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={5}>
        <h2
          style={{
            fontWeight: 400,
            marginBottom: '1em',
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Create New Manufacturer Variant
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row loading={loading}>
      <Grid.Column width={8}>
        <Form>
          <Form.Field required>
            <label>Select Manufacturer</label>
            <Dropdown
              placeholder="Select Manufacturer"
              loading={loading}
              selection
              search
              options={manufacturersDD}
              onChange={onChangeOfManufacturerId}
            />
          </Form.Field>
          <Form.Field required>
            <label>Select Variant</label>
            <Dropdown
              placeholder="Select Variant"
              loading={loading}
              selection
              search
              options={variantsDD}
              onChange={onChangeOfVariantId}
            />
          </Form.Field>
          <Form.Field required>
            <label>MRP (in Rs.)</label>
            <input placeholder="50" onChange={onChangeOfMrp} />
          </Form.Field>
          <Form.Field required>
            <label>Offer Price (in Rs.)</label>
            <input placeholder="40" onChange={onChangeOfOfferPrice} />
          </Form.Field>
          <Form.Field required>
            <label>Vendor Price (in Rs.)</label>
            <input placeholder="40" onChange={onChangeOfVendorPrice} />
          </Form.Field>

          <Button
            basic
            color="blue"
            style={{ float: 'right' }}
            disabled={submitLoading}
            loading={submitLoading}
            onClick={handleSubmit}
          >
            Add Manufacturer Variant
          </Button>
        </Form>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default CreateMVForm;



// WEBPACK FOOTER //
// ./src/Modules/CreateNewManufacturerVariant/component.jsx